import memoize from 'lodash/memoize';
import { FormatNumberAtomFn } from '../../types';
import { commaToDisplayFormat, formatZeroCountAfterDotAtom } from '../numberAtoms';
import { combineFormatAtoms } from '../base';
import { FloatFormatAtomProps } from '../../types';
import { isUndefined } from '../../../../predicates/type';

export const floatFormat = memoize((options?: FloatFormatAtomProps) => {
	return (value: unknown) => {
		const atoms: Array<FormatNumberAtomFn> = [commaToDisplayFormat];

		if (!isUndefined(options?.decimalScale)) {
			atoms.push(formatZeroCountAfterDotAtom);
		}

		return combineFormatAtoms(atoms, value, options) as string;
	};
});
